<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div v-if="getUserData && getUserData.email" class="btn btn-light mr-2" data-testid="user-menu">
        <i class="fa fa-user mr-2" />
        <span class="d-none d-sm-inline">{{ getUserData.email }}</span>
      </div>
    </template>
    <template slot="dropdown">
      <router-link class="dropdown-item" :to="{ name: 'Common.UserProfiles.View', params: {id: getUserData.id} }">
        <i class="fa fa-vcard" /> My Profile
      </router-link>
      <router-link class="dropdown-item" :to="{ name: 'Common.MyAccount' }">
        <i class="fa fa-cogs" /> Account Settings
      </router-link>
      <b-dropdown-item data-testid="logout" @click="logout">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters('account', [
      'getUserData',
      'isLoggedIn'
      // ...
    ])
  },
  methods: {
    logout() {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('auth_token');
      window.$cookie.set('auth_token', '');
      this.$cookie.remove('auth_token');
      this.$store.dispatch('account/logout');
      //this.$router.push({ name: 'Login', query: { '_r': (Math.random().toString(36).substring(2, 5)) } });
      window.location.replace('/login?_r='+ (Math.random().toString(36).substring(2, 5)));
    }
  }
};
</script>
